export const HOME_NAV_SECTIONS = [
  { id: 'competences', labelKey: 'nav_skills' },
  { id: 'projets', labelKey: 'nav_projects' },
  { id: 'parcours', labelKey: 'nav_parcours' },
  { id: 'certifications', labelKey: 'nav_certifications' },
];

export const HOME_CONTACT_SECTION_ID = 'contact';

export const homeSectionHref = (sectionId) => `/#${sectionId}`;
